import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

/**
 * Repository for the admin customer endpoints (backend `customer` service):
 * the blocking surface the moderation view needs, plus the read-only search
 * behind the customer lookup screen.
 */
export default class CustomerRepository extends EntityBaseRepository {
    public listBlocked(): Promise<AxiosResponse> {
        return this.axiosClient.get('customer/blocked');
    }

    /**
     * Path segment, so it is encoded for the same reason as
     * DriverRepository.searchDriver: the query fires while the user types.
     */
    public search(query: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`customer/search/${encodeURIComponent(query)}`);
    }

    public block(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`customer/${payload.id}/block`, { reason: payload.reason });
    }

    public unblock(payload: { id: string, reason: string }): Promise<AxiosResponse> {
        return this.axiosClient.post(`customer/${payload.id}/unblock`, { reason: payload.reason });
    }
}
